import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SidenavItem } from 'src/app/shared/interfaces/sidenav-item.interface';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-navigation-item',
    templateUrl: './navigation-item.component.html',
    styleUrls: ['./navigation-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationItemComponent extends BaseComponent implements OnInit {

  @Input('item') public item: SidenavItem;
  @Input('currentlyOpen') public currentlyOpen: SidenavItem[] = [];

  @Output() public handleClick = new EventEmitter<SidenavItem>();

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
